import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from 'assets/icons/close-icon'

import { AlertBoxContainer, AlertMessage, CloseButton } from './style'

const CloseableAlertBox = ({ message, onClose }) => (
  <AlertBoxContainer>
    <AlertMessage>{message}</AlertMessage>
    <CloseButton onClick={onClose}>
      <CloseIcon />
    </CloseButton>
  </AlertBoxContainer>
)

CloseableAlertBox.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default CloseableAlertBox
